export default __webpack_public_path__ + "static/media/done-check-switch.059903fd.gif";